
import Vue, { PropType } from 'vue'
import { RButton } from '@/components'

type AvailableOptions = 'download' | 'delete' | 'rename'

export default Vue.extend({
  name: 'BrowserDirectoryFileOptions',
  components: {
    RButton,
  },
  props: {
    options: {
      type: Object as PropType<AvailableOptions[]>,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShared: {
      type: Boolean,
      default: false,
    },
  },
})
